import {
  FDContentContainer,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import React from 'react';
import useBoneBackgroundColor from 'Hooks/useBoneBackgroundColor';
import useMobileLayout from 'Hooks/useMobileLayout';
import Footer from 'Components/ClientApp/Desktop/Footer';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { UpgradeWidget } from 'Views/Page/Content/Templates/TaxDashboardPage/Components/UpgradeWidget';
import { JourneyWidget } from './Components/JourneyWidget';
import { MainContent } from './Components/MainContent';
import { AskAnExpertWidget } from './Components/AskAnExpertWidget';

const useStyles = buildUseStyles('ReferralPage', () => ({
  footer: {
    position: 'sticky',
    transform: 'initial',
    bottom: 'unset',
  },
  wrapText: {
    wordWrap: 'break-word',
  },
}));

export const Layout = () => {
  const { resource } = useMetaLayoutContext();
  const isMobile = useMobileLayout();
  const classes = useStyles();
  const { loadPageContentLink } = usePageContentContext();

  useBoneBackgroundColor();

  return (
    <>
      <FDContentContainer maxWidth={'xl'}>
        <FDStack direction={isMobile ? 'column' : 'row'} spacing={4} paddingY={isMobile ? 4 : 8} wrap>
          <FDStack direction={'column'} spacing={3} flex={4} width={'100%'}>
            <FDStack direction={isMobile ? 'column' : 'row'} alignItems={'flex-start'} spacing={8} flex={1}>
              <MainContent resource={resource} />
              <FDStack direction={'column'} spacing={3} maxWidth={isMobile ? undefined : 450}>
                <JourneyWidget collection={resource.attr('journeySteps')} />
                <UpgradeWidget resource={resource} />
                <AskAnExpertWidget resource={resource} />
              </FDStack>
            </FDStack>
          </FDStack>
        </FDStack>
        {
          resource.withRelationship(fr.relationships.taxFilingPartnerPage.name, (rel) => {
            return <FDTextButton onClick={() => loadPageContentLink(rel.link('related'))} label={'File taxes'} />;
          }, () => null)
        }
      </FDContentContainer>

      {!isMobile && <Footer className={classes.footer} />}
    </>
  );
};
